import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { PendenciaDto } from '../../dominios/pendencias/tipos/pendencia'
import { pendenciaService } from '../../dominios/pendencias/services/pendencia'
import { useMutationWithToast } from '../../hooks/useMutationWithToast'

interface ToastPendenciaProps {
  pendencia: PendenciaDto
  onClose: () => void
}

export function ToastPendencia({ pendencia, onClose }: ToastPendenciaProps) {
  const navigate = useNavigate()

  const marcarLidaMutation = useMutationWithToast({
    mutationFn: async (_variables?: void) => {
      await pendenciaService.marcarComoLida(pendencia.idPendencia)
    },
    successMessage: 'Pendência marcada como lida',
    errorMessage: 'Erro ao marcar pendência como lida',
    onSuccess: () => {
      handleAcao()
    }
  })

  const handleAcao = () => {
    if (pendencia.rotaDestino) {
      navigate(pendencia.rotaDestino)
    } else {
      navigate(`/pendencias/${pendencia.idPendencia}`)
    }
    onClose()
  }

  const handleMarcarLida = async () => {
    if (!pendencia.lida) {
      await marcarLidaMutation.mutateAsync(undefined)
    } else {
      handleAcao()
    }
  }

  // Auto-dismiss após 10 segundos
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose()
    }, 10000)

    return () => clearTimeout(timer)
  }, [onClose])

  return (
    <div className="bg-white rounded-lg shadow-lg border border-gray-200 p-4 min-w-[320px] max-w-md">
      <div className="flex items-start justify-between mb-2">
        <div className="flex-1">
          <h4 className="font-semibold text-gray-900 mb-1">{pendencia.titulo}</h4>
          {pendencia.descricao && (
            <p className="text-sm text-gray-600 mb-2">{pendencia.descricao}</p>
          )}
          <div className="flex items-center gap-2 text-xs text-gray-500">
            <span className="px-2 py-0.5 bg-gray-100 rounded">{pendencia.tipo}</span>
            {pendencia.usuarioCriadorNome && (
              <span>Por: {pendencia.usuarioCriadorNome}</span>
            )}
          </div>
        </div>
        <button
          onClick={onClose}
          className="ml-2 text-gray-400 hover:text-gray-600"
        >
          ×
        </button>
      </div>
      <div className="flex gap-2 mt-3">
        <button
          onClick={handleMarcarLida}
          className="flex-1 px-3 py-1.5 text-sm bg-brand-500 text-white rounded-lg hover:bg-brand-600 transition-colors"
        >
          Ver
        </button>
      </div>
    </div>
  )
}

